import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Tizen.png")